import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Quote, ChevronRight } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(`${API}/testimonials`);
      setTestimonials(response.data);
    } catch (err) {
      console.error('Failed to fetch testimonials', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="pt-20 min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="pt-20" data-testid="testimonials-page">
      {/* Header */}
      <section className="bg-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
          <p className="text-orange-500 font-heading text-sm uppercase tracking-widest mb-3">
            What Our Customers Say
          </p>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Testimonials
          </h1>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Don't just take our word for it. Hear from the Alaskans who trust 
            Armageddon Boats for their adventures.
          </p>
        </div>
      </section>

      {/* Testimonials List */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <div className="space-y-12">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id}
                className="bg-white border-2 border-slate-100 p-8 md:p-12 relative"
                data-testid={`testimonial-${index}`}
              >
                <Quote className="w-12 h-12 text-orange-500 opacity-30 absolute top-6 left-6" />
                
                <blockquote className="relative z-10">
                  <p className="text-lg md:text-xl text-slate-700 leading-relaxed pl-8 md:pl-12">
                    "{testimonial.quote}"
                  </p>
                  
                  <footer className="mt-8 pl-8 md:pl-12">
                    <cite className="not-italic">
                      <span className="font-heading text-xl font-bold text-slate-900 uppercase">
                        {testimonial.author}
                      </span>
                      {testimonial.location && (
                        <span className="block text-orange-500 mt-1">
                          {testimonial.location}
                        </span>
                      )}
                    </cite>
                  </footer>
                </blockquote>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-slate-900 py-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Join Our Happy Customers?
          </h2>
          <p className="text-lg text-slate-400 mb-8 max-w-xl mx-auto">
            Start your custom boat project today and experience the Armageddon difference.
          </p>
          <Link to="/contact" className="btn-primary inline-flex items-center gap-2">
            Get a Quote
            <ChevronRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
